/** /admin/reports/receivables — Sundry Debtors (Receivables). */
import { Users2 } from 'lucide-react';
import { BalancesReport } from '../../components/BalancesReport';
export default function ReceivablesPage() {
  return <BalancesReport title="Receivables" endpoint="/api/tally-import/outstanding/receivables" icon={Users2} emptyText="No sundry debtors with an outstanding balance." />;
}
